// components/ui/ModernCard.tsx
import React from 'react';

interface ModernCardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}

export const ModernCard: React.FC<ModernCardProps> = ({ 
  children, 
  className = "", 
  onClick = undefined, 
  hover = false 
}) => (
  <div 
    className={`
      bg-white rounded-2xl shadow-sm border border-gray-100 
      transition-all duration-200
      ${hover ? 'hover:shadow-lg hover:border-gray-200 hover:-translate-y-1' : ''}
      ${onClick ? 'cursor-pointer' : ''}
      ${className}
    `}
    onClick={onClick}
  >
    {children}
  </div>
);